// // import React, { useState } from "react";

// // export default function Unleashing() {
// //   const [active, setActive] = useState(1);

// //   const services = [
// //     {
// //       id: 1,
// //       title: "Machine Learning Solutions",
// //       img: "https://validthemes.net/site-template/robok/assets/img/services/1.jpg",
// //     },
// //     {
// //       id: 2,
// //       title: "AI Strategy and Consulting",
// //       img: "https://validthemes.net/site-template/robok/assets/img/services/2.jpg",
// //     },
// //     {
// //       id: 3,
// //       title: "AI Integration and Deployment",
// //       img: "https://validthemes.net/site-template/robok/assets/img/services/3.jpg",
// //     },
// //     {
// //       id: 4,
// //       title: "Data Analytics and Insights",
// //       img: "https://validthemes.net/site-template/robok/assets/img/services/4.jpg",
// //     },
// //   ];

// //   return (
// //     <>
// //       <div className="services-style-six-area bg-cover default-padding bg-gray blurry-shape-left-bottom">
// //         <div className="container">
// //           <div className="row">
// //             <div className="col-lg-5">
// //               <div className="service-tab-content-box">
// //                 <div className="service-tab-content-box">
// //                   {services.map((service) => (
// //                     <div
// //                       key={service.id}
// //                       className={`service-tab-contents ${
// //                         active === service.id ? "active" : ""
// //                       }`}
// //                     >
// //                       <img src={service.img} alt="service" />
// //                     </div>
// //                   ))}
// //                 </div>
// //               </div>
// //             </div>
// //             <div className="col-lg-7 pl-70 pl-md-15 pl-xs-15">
// //               <h4 className="sub-title">Services</h4>
// //               <h2 className="title split-text-right split-text-in-right">
// //                 AI-optimized design for innovative futures
// //               </h2>
// //               <ul className="service-tab-content-list">
// //                 {services.map((service) => (
// //                   <li
// //                     key={service.id}
// //                     className={`service-item ${active === service.id ? "active" : ""}`}
// //                     onMouseEnter={() => setActive(service.id)}
// //                   >
// //                     <div className="service-tab-item">
// //                       <span className="number">0{service.id}</span>
// //                       <span className="text">{service.title}</span>
// //                     </div>
// //                   </li>
// //                 ))}
// //               </ul>
// //             </div>
// //           </div>
// //         </div>
// //       </div>
// //       ;
// //     </>
// //   );
// // }

// import React, { useState } from "react";

// export default function Unleashing() {
//   const [active, setActive] = useState(1);

//   const services = [
//     {
//       id: 1,
//       title: "Machine Learning Solutions",
//       img: "https://validthemes.net/site-template/robok/assets/img/services/1.jpg",
//     },
//     {
//       id: 2,
//       title: "AI Strategy and Consulting",
//       img: "https://validthemes.net/site-template/robok/assets/img/services/2.jpg",
//     },
//     {
//       id: 3,
//       title: "AI Integration and Deployment",
//       img: "https://validthemes.net/site-template/robok/assets/img/services/3.jpg",
//     },
//     {
//       id: 4,
//       title: "Data Analytics and Insights",
//       img: "https://validthemes.net/site-template/robok/assets/img/services/4.jpg",
//     },
//   ];

//   const activeService = services.find((s) => s.id === active);

//   return (
//     <div className="services-style-six-area default-padding bg-gray">
//       <div className="container">
//         <div className="row align-items-center">
//           {/* LEFT IMAGE */}
//           <div className="col-lg-5 col-12 mb-4 mb-lg-0">
//             <div className="service-image-wrapper">
//               <img
//                 src={activeService.img}
//                 alt="service"
//                 className="img-fluid rounded"
//               />
//             </div>
//           </div>

//           {/* RIGHT CONTENT */}
//           <div className="col-lg-7 col-12">
//             <h4 className="sub-title">Services</h4>
//             <h2 className="title">
//               AI-optimized design for innovative futures
//             </h2>

//             <ul className="service-tab-content-list">
//               {services.map((service) => (
//                 <li
//                   key={service.id}
//                   className={`service-item ${
//                     active === service.id ? "active" : ""
//                   }`}
//                   onMouseEnter={() => setActive(service.id)}
//                 >
//                   <span className="number">0{service.id}</span>
//                   <span className="text">{service.title}</span>
//                 </li>
//               ))}
//             </ul>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

import React from "react";
import {
  FaCogs,
  FaShieldAlt,
  FaSlidersH,
  FaCoins,
  FaLock,
  FaIdCard,
} from "react-icons/fa";

function Unleashing() {
  return (
    <>
      <div
        className="process-style-two-area overflow-hidden bg-cover default-padding bg-dark text-light"
        style={{
          backgroundImage:
            "url(https://validthemes.net/site-template/robok/assets/img/shape/banner-20.jpg)",
        }}
      >
        <div className="container">
          <div className="site-heading">
            <div className="row align-center">
              <div className="col-lg-6">
                <h4 className="sub-title">Our Process</h4>
                <h2 className="title split-text-right split-text-in-right split-lines">
                  Features of P2P Crypto Exchange
                </h2>
              </div>
              {/* <div className="col-lg-5 offset-lg-1">
                <p>
                  These features of Ethereum wallet securely manage Ethereum and
                  its diverse ecosystem of tokens and dApps.
                </p>
              </div> */}
            </div>
          </div>
        </div>
        <div className="container">
          <div className="process-style-two-items">
            <div className="row">
              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon pb-30">
                    <FaCogs size={50} />
                  </div>
                  <h4>Powerful Trading Engine</h4>
                  <p>
                    Facilitate direct transactions between buyers and sellers,
                    eliminating the need for centralized authorities and
                    reducing operational risks.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon pb-30">
                    <FaShieldAlt size={42} />
                  </div>
                  <h4>Secure Escrow System</h4>
                  <p>
                    Our built-in escrow service ensures that funds are held
                    securely during the transaction, providing a safe and
                    reliable environment for users.
                  </p>
                  <br />
                </div>
              </div>

              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon pb-30">
                    <FaSlidersH size={42} />
                  </div>
                  <h4>Customizable Platform</h4>
                  <p>
                    Tailor the P2P exchange platform to your specific business
                    requirements with advanced features, a user-friendly
                    interface, and flexible design options.
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon pb-30">
                    <FaCoins size={42} />
                  </div>
                  <h4>Multi-Currency Support</h4>
                  <p>
                    Support a wide range of cryptocurrencies to attract a
                    diverse user base and provide traders with a comprehensive
                    marketplace.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon pb-30">
                    <FaLock size={42} />
                  </div>
                  <h4>Robust Security</h4>
                  <p>
                    We implement advanced security features like two-factor
                    authentication (2FA), end-to-end encryption, and
                    anti-phishing measures to protect users and their assets.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 ">
                <div className="process-style-two-item">
                  <div className="icon pb-30">
                    <FaIdCard size={42} />
                  </div>
                  <h4>KYC/AML Integration</h4>
                  <p>
                    Seamlessly incorporate Know Your Customer (KYC) and
                    Anti-Money Laundering (AML) processes to ensure regulatory
                    compliance and safeguard user identities.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Unleashing;
